import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, take, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
// import mathjs package functions
const math = require('mathjs');
import { TagValueComponent } from '../../tag-value-dialog-model/tag-value-dialog-model.component';
import { DynamicDrawerService } from 'app/shared/dynamic-drawer.service';
import { ICalTagDetail, TagDetail } from 'app/services/graphqlApi.service';
import { DataService } from 'app/shared/data/data.service';
import { IModelComponents, ISelectedTag } from '../../interfaces/tag-type';
import { IDropdown } from 'app/shared/interfaces/model';
import { ICalculatedTagDetail, ITagInputs, Tag } from '../../interfaces/tag';
import { ECalTagsItemsTypes, EEntityTypes, EReturnTypes, ETagPropertyDataType } from 'app/shared/enums';
import { Property } from 'app/shared/create-properties/interfaces/interfaces';
import { ITimeAggregation } from 'app/shared/interfaces/component';
import { ComponentsService } from 'app/components/services/components.service';
import { ITranslate } from 'app/shared/constants';

@Component({
  selector: 'app-calculate-tag',
  templateUrl: './calculate-tag.component.html',
  styleUrls: ['./calculate-tag.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CalculateTagComponent implements OnInit {
  @Input() allTags: TagDetail[] = [];
  @Input() formGroupTags: FormGroup;
  @Input() selectedTagType: { name: string, id: string };
  @Input() allModelTags: TagDetail[] = [];
  @Input() set calTagDetail(calTagDetail: ICalTagDetail) {
    if (calTagDetail) {
      this.viewCalTagDetail = calTagDetail;
      this.componentsService.aggregations$.pipe(takeUntil(this.destroyed)).subscribe((aggregations: ITimeAggregation[]) => {

        // set actual tags, props, aggrs and CI name dynamic for cal expressions
        this.dataService.tags$.pipe(take(1)).subscribe((tags: TagDetail[]) => {
          const allTags: TagDetail[] = [...tags];
          this.allModelTags = this.isModelPage ? [...tags] : [];
          allTags.forEach((tag: TagDetail) => {
            tag.dummyName = tag.componentInstanceName ? tag.componentInstanceName + '.' + tag.name : tag.name;
            if (this.viewCalTagDetail.script_input_tags?.length) {
              this.viewCalTagDetail.script_input_tags.forEach((inputTag: ITagInputs) => {
                if (tag.id === inputTag.id && !inputTag.componentInstanceId) {
                  this.viewCalTagDetail.script = this.viewCalTagDetail.script.replaceAll('${' + inputTag.name + '}', '${' + tag.name + '}');
                  inputTag.name = tag.name;
                } else if (tag.id === inputTag.id && tag.componentInstanceId === inputTag.componentInstanceId) {
                  this.viewCalTagDetail.script = this.viewCalTagDetail.script.replaceAll('${' + inputTag.name + '}', '${' + tag.componentInstanceName + '.' + tag.name + '}');
                  inputTag.name = tag.componentInstanceName + '.' + tag.name;
                }
              });
            }
          });
        });

        this.viewCalTagDetail.script_input_props?.forEach((inputProp: ITagInputs) => {
          this.allProperties.find((prop: Property) => {
            if (prop.id === inputProp.id && !inputProp.componentInstanceId) {
              this.viewCalTagDetail.script = this.viewCalTagDetail.script.replaceAll('${' + inputProp.name + '}', '${' + prop.name + '}');
              inputProp.name = prop.name;
            } else if (prop.id === inputProp.id && prop.componentInstanceId === inputProp.componentInstanceId) {
              this.viewCalTagDetail.script = this.viewCalTagDetail.script.replaceAll('${' + inputProp.name + '}', '${' + prop.componentInstanceName + '.' + prop.name + '}');
              inputProp.name = prop.componentInstanceName + '.' + prop.name;
            }
          });
        });

        this.viewCalTagDetail.agg_configs?.forEach((inputAggr: ITagInputs) => {
          console.log('aggregations:1111 ', aggregations);
          aggregations.find((aggr: ITimeAggregation) => {
            if (aggr.id === inputAggr.id && !inputAggr.componentInstanceId) {
              this.viewCalTagDetail.script = this.viewCalTagDetail.script.replaceAll('${' + inputAggr.name + '}', '${' + aggr.name + '}');
              inputAggr.name = aggr.name;
            } else if (aggr.id === inputAggr.id && aggr.compInstanceId === inputAggr.componentInstanceId) {
              this.viewCalTagDetail.script = this.viewCalTagDetail.script.replaceAll('${' + inputAggr.name + '}', '${' + aggr.compInstanceName + '.' + aggr.name + '}');
              inputAggr.name = aggr.compInstanceName + '.' + aggr.name;
            }
          });
        });

        this.loadData(this.viewCalTagDetail, this.allTags?.length ? this.allTags : this.allModelTags);
      });
    }
  }

  @Output() calculatedTagDetail = new EventEmitter<ICalculatedTagDetail>();
  readonly destroyed = new ReplaySubject(1);
  viewCalTagDetail: ICalTagDetail;
  isModel: boolean = false;
  isModelCreate: boolean = false;
  cursorPosition: number = 0;
  itemsDetail: ISelectedTag[] = [];
  itemsCalculatedResult: IDropdown[] = [];
  allComponents: IModelComponents[] = [];
  allProperties: Property[] = [];
  allModelProperties: Property[] = [];
  allAggregations: ITimeAggregation[] = [];
  allModelAggregations: ITimeAggregation[] = [];
  selectedModel: IDropdown[] = [];
  selectedEntity: IModelComponents;
  resultType: string;
  calculatedTagInfo: ICalculatedTagDetail;
  trans: ITranslate = { text: '' }; // for translation


  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly toastr: ToastrService,
    private readonly dialog: MatDialog,
    private readonly translate: TranslateService,
    private readonly componentsService: ComponentsService,
    private readonly dataService: DataService,
    private readonly dynamicDrawerService: DynamicDrawerService<Tag>) { }

  ngOnInit() {
    // get time aggregations
    const aggrgegations: ITimeAggregation[] = this.componentsService._aggregations.getValue();
    this.allAggregations = [...aggrgegations];
    this.allModelAggregations = this.isModelPage ? [...aggrgegations] : [];
    if (!this.allAggregations.length) {
      this.getTimeAggregations();
    }

    this.dynamicDrawerService.createTagFromModel$.pipe(takeUntil(this.destroyed)).subscribe((createTagFromModel: boolean) => {
      this.isModelCreate = createTagFromModel;
    });

    // get model components
    if (this.isModelPage) {
      this.dataService.modelComponents$.pipe(takeUntil(this.destroyed)).subscribe(modelComponents => {
        this.allComponents = modelComponents;
        this.selectedModel.push({ name: this.allComponents[0].modelName, value: this.allComponents[0].modelId });
      });
    }

    if (this.allModelTags?.length) {
      this.isModel = true;
      this.allTags = [];
    }

    if (this.viewCalTagDetail) {
      // load data
      this.loadData(this.viewCalTagDetail, this.allTags?.length ? this.allTags : this.allModelTags);
    }

    // get properties
    this.dataService.properties$.pipe(filter((properties) => !!properties)).subscribe((properties: Property[]) => {
      if (properties.length) {
        properties.forEach((property: Property) => {
          property.dummyName = property.componentInstanceName ? property.componentInstanceName + '.' + property.name : property.name;
        });

        this.allProperties = [...properties];
        this.allModelProperties = [...properties];
        console.log('this.allProperties: ', this.allProperties);
      }
    });
        // translation
        this.translate.onLangChange.subscribe(langChange => this.getTranslation());
        this.getTranslation();
  }

      /**
   * get translation
   */
      getTranslation(){
        this.translate.get('Component').subscribe(components => this.trans = components );
      }
  //#region load data (on edit)

  get isModelPage() {
    return this.router.url.includes(EEntityTypes.MODELS);
  }

  get isAssetPage() {
    return this.router.url.includes(EEntityTypes.ASSETS);
  }

  /**
   * load data
   * @param calTagDetail cal tag Detail (for view)
   */
  loadData(calTagDetail: ICalTagDetail, allTags: TagDetail[]) {
    this.formGroupTags?.patchValue({ calculated: calTagDetail.script });
    if (calTagDetail) {
      this.itemsDetail = [];
      this.itemsCalculatedResult = [];
      console.log('calTagDetail.script_input_tags: ', calTagDetail.script_input_tags);
      calTagDetail.script_input_tags?.filter((inputTag: ITagInputs) => {
        if (inputTag.id && inputTag.name) {
          this.itemsDetail.push({ name: inputTag.name, type: null, itemType: ECalTagsItemsTypes.Tag, value: null, variable: '${' + inputTag.name + '}' })
        }
      });

      calTagDetail.script_input_props?.filter((inputProp: ITagInputs) => {
        if (inputProp.id && inputProp.name) {
          this.itemsDetail.push({ name: inputProp.name, type: null, itemType: ECalTagsItemsTypes.Property, value: null, variable: '${' + inputProp.name + '}' })
        }
      });

      calTagDetail.agg_configs?.filter((inputAggr: ITagInputs) => {
        if (inputAggr.id && inputAggr.name) {
          this.itemsDetail.push({ name: inputAggr.name, type: ETagPropertyDataType.Number, itemType: ECalTagsItemsTypes.Aggregation, value: null, variable: '${' + inputAggr.name + '}' })
        }
      });

      // assign tag types
      allTags?.filter((tag: TagDetail) => {
        this.itemsDetail?.forEach((tagDetail: ISelectedTag) => {
          if (tag.dummyName && tag.dummyName === tagDetail.name) {
            tagDetail.type = tag.tagType;
          } else if (tag.name === tagDetail.name) {
            tagDetail.type = tag.tagType;
          }
        });
      });

      // assign property types
      this.allProperties?.filter((prop: Property) => {
        this.itemsDetail?.forEach((tagDetail: ISelectedTag) => {
          if (prop.dummyName === tagDetail.name) {
            tagDetail.type = prop.propertyType;
          }
        });
      });

      console.log('this.itemsDetail:555 ', this.itemsDetail);
      // assign result
      this.itemsCalculatedResult.push({ name: this.formGroupTags?.value?.name, value: null })
    }
  }

  //#endregion

  //#region tag calculation

  /**
   * evaluating result of expression
   * @param expression mathematical expression
   */
  evalExecute(expression: HTMLInputElement) {
    const splittedExpressions: string[] = expression?.value?.split(';');
    if (splittedExpressions?.length && splittedExpressions[0] !== '') {
      for (var j = 0; j < splittedExpressions.length; j++) {
        // get all used items and remove duplicates
        let allUsedItems: string[] = [];
        allUsedItems = [...new Set(splittedExpressions[j].match((/\${([^}]+)}/g))?.map(function (str) { return str.slice(2, -1) }))];
        console.log('allUsedItems:777 ', allUsedItems);
        console.log('this.allTags:777 ', this.allTags);
        console.log('this.allModelTags:777 ', this.allModelTags);
        console.log('this.allModelProperties:777 ', this.allModelProperties);


        // for model->tags
        if (allUsedItems?.length && this.isModel) {
          this.allModelTags?.forEach(modelTag => {
            if (allUsedItems.includes(modelTag?.dummyName) || (!modelTag.componentInstanceId && allUsedItems.includes(modelTag?.name))) {
              if (!this.allTags?.some(x => x?.dummyName === modelTag?.dummyName)) {
                this.allTags.push(modelTag);
              }
            }
          });

          // add new added tags
          this.allTags?.forEach((tag: TagDetail) => {
            allUsedItems.forEach((usedItem: string) => {
              if ((tag.dummyName === usedItem || (!tag.componentInstanceId && tag.name === usedItem))) {
                if (!this.itemsDetail.some(itemDetail => itemDetail.name === usedItem)) {
                  const itemName: string = tag.dummyName ?? tag.name;
                  const tagType: string = (tag.tagType === ETagPropertyDataType.Calculated) ? (tag.calc_tag_config.output_type === EReturnTypes.Numeric) ? ETagPropertyDataType.Number : tag.calc_tag_config.output_type : tag.tagType;
                  this.itemsDetail.push({ name: itemName, type: tagType, itemType: ECalTagsItemsTypes.Tag, value: null, variable: '${' + itemName + '}' })
                }
              }
            });
          });

          this.allModelProperties?.forEach((property: Property) => {
            allUsedItems.forEach((usedItem: string) => {
              console.log('usedItem: ', usedItem);
              if ((property.dummyName === usedItem || (!property.componentInstanceId && property.name === usedItem))) {
                if (!this.itemsDetail.some(x => x.name === usedItem)) {
                  const itemName: string = property.dummyName ?? property.name;
                  this.itemsDetail.push({ name: itemName, type: property.propertyType, itemType: ECalTagsItemsTypes.Property, value: null, variable: '${' + itemName + '}' })
                }
              }
            });
          });

          const aggrgegations: ITimeAggregation[] = this.componentsService._aggregations.getValue();
          console.log('aggrgegations:777 ', aggrgegations);
          this.allModelAggregations = [...aggrgegations];
          this.allModelAggregations?.forEach((aggr: ITimeAggregation) => {
            allUsedItems.forEach((usedItem: string) => {
              if ((aggr.dummyName === usedItem || (!aggr.compInstanceId && aggr.name === usedItem))) {
                if (!this.itemsDetail.some(x => x.name === usedItem)) {
                  const itemName: string = aggr.dummyName ?? aggr.name;
                  this.itemsDetail.push({ name: itemName, type: ETagPropertyDataType.Number, itemType: ECalTagsItemsTypes.Aggregation, value: null, variable: '${' + itemName + '}' })
                }
              }
            });
          });
        }

        // for component tags
        else {
          // add new added tags
          if (allUsedItems?.length && (this.allTags?.length || this.allProperties.length || this.allAggregations.length)) {
            this.allTags.filter((tag: TagDetail) => {
              allUsedItems.forEach((usedTag: string) => {
                if (tag.name === usedTag) {
                  if (!this.itemsDetail.some(x => x.name === usedTag)) {
                    const tagType: string = (tag.tagType === ETagPropertyDataType.Calculated) ? (tag.calc_tag_config.output_type === EReturnTypes.Numeric) ? ETagPropertyDataType.Number : tag.calc_tag_config.output_type : tag.tagType;
                    this.itemsDetail.push({ name: tag.name, itemType: ECalTagsItemsTypes.Tag, type: tagType, value: null, variable: '${' + tag.name + '}' })
                  }
                }
              });
            });

            this.allProperties.filter((prop: Property) => {
              allUsedItems.forEach((usedTag: string) => {
                if (prop.name === usedTag) {
                  if (!this.itemsDetail.some(x => x.name === usedTag)) {
                    this.itemsDetail.push({ name: prop.name, itemType: ECalTagsItemsTypes.Property, type: prop.propertyType, value: null, variable: '${' + prop.name + '}' })
                  }
                }
              });
            });

            this.allAggregations.filter((aggr: ITimeAggregation) => {
              allUsedItems.forEach((usedTag: string) => {
                if (aggr.name === usedTag) {
                  if (!this.itemsDetail.some(x => x.name === usedTag)) {
                    this.itemsDetail.push({ name: aggr.name, itemType: ECalTagsItemsTypes.Aggregation, type: ETagPropertyDataType.Number, value: null, variable: '${' + aggr.name + '}' })
                  }
                }
              });
            });
          }
        }

        // remove recent removed items
        this.removeRecentRemovedItems(allUsedItems);

        if (this.itemsDetail?.length) {
          // open dialog model to assign values to variables
          this.openValueAssismentModel(j);
        } else {
          this.itemsDetail = [];
          // execute given expression
          this.execute(splittedExpressions[j], j);
        }
      }
    } else {
      this.toastr.error("Please enter a valid expression.", "Error!");
    }
  }

  /**
   * remove recent removed items
   * @param allUsedItems all used items
   */
  removeRecentRemovedItems(allUsedItems: string[]) {
    var i: number = 0;
    while (i < this.itemsDetail?.length) {
      const tag: ISelectedTag = this.itemsDetail[i];
      if (!allUsedItems.includes(tag.name)) {
        this.itemsDetail.splice(i, 1);
      } else {
        i += 1;
      }
    };
  }

  /**
   * execute expression
   * @param expression expression
   * @param index index
   * @param tagDetails tag details (array)
   */
  execute(expression, index, tagDetails?: ISelectedTag[]) {
    console.log('expression: ', expression);
    console.log('tagDetails: ', tagDetails);
    this.itemsCalculatedResult = [];
    try {
      var parameters = '';
      var functionBody = expression;

      if (tagDetails?.length) {
        tagDetails.forEach(tag => {
          if (parameters) {
            parameters = parameters + ", " + tag.name;
          } else {
            parameters = tag.name;
          }
          if (typeof (tag.value) !== 'number')
            functionBody = functionBody.replaceAll(tag.variable, "'" + tag.value + "'");
          else
            functionBody = functionBody.replaceAll(tag.variable, tag.value);
        });
      }

      var functStruct = `(function a()` + '{ ' + functionBody + ' } )';
      // console.log('functStruct: ', functStruct);
      var evaluated = eval(functStruct);
      // console.log('evaluated: ', evaluated);
      var result = evaluated();
      console.log('result:111 ', result);
      if (String(result)) {
        this.calculatedTagInfo = {
          script: expression,
          outputType: this.getOutputType(result),
          scriptInputTags: this.itemsDetail.filter(item => item.itemType === ECalTagsItemsTypes.Tag),
          aggConfigs: this.itemsDetail.filter(item => item.itemType === ECalTagsItemsTypes.Aggregation),
          scriptInputProps: this.itemsDetail.filter(item => item.itemType === ECalTagsItemsTypes.Property),
        }

        // model cal tags validation "Select atleast one "model cal tag" or tags against more than one "component instance"
        let isInvalid: boolean = false;
        let isModelCalculatedExists: boolean = false;
        if (this.isModelPage) {
          const selectedItems: string[] = [];

          console.log('this.allModelTags:666 ', this.allModelTags);
          console.log('allModelProperties:666 ', this.allModelProperties);
          console.log('this.allAggregations:666 ', this.allAggregations);
          console.log('this.itemsDetail:666 ', this.itemsDetail);

          this.itemsDetail?.filter((selectedItem: ISelectedTag) => {
            // model tags
            this.allModelTags?.filter((tag: TagDetail) => {
              const tName: string = tag.dummyName || tag.name;
              if (selectedItem.name === tName) {
                var itemName: string[] = selectedItem.name?.split(".");
                console.log('itemName:111 ', itemName);
                // check for model tags
                if (itemName?.length === 1) {
                  itemName = [tag.entityType, itemName[0]];
                }

                if (itemName?.length && (!selectedItems.includes(itemName[0]))) {
                  selectedItems.push(itemName[0]);
                }
              }
            });

            // model props
            this.allModelProperties?.filter((prop: Property) => {
              const pName: string = prop.dummyName;
              if (selectedItem.name === pName) {
                var itemName: string[] = selectedItem.name?.split(".");
                // check for model prop
                if (itemName?.length === 1) {
                  itemName = [prop.entityType, itemName[0]];
                }

                if (itemName?.length && (!selectedItems.includes(itemName[0]))) {
                  selectedItems.push(itemName[0]);
                }

              }
            });

            // model aggrs
            this.allModelAggregations?.filter((aggr: ITimeAggregation) => {
              const aggrName: string = aggr.dummyName;
              if (selectedItem.name === aggrName) {
                var itemName: string[] = selectedItem.name?.split(".");
                // check for model aggr
                if (itemName?.length === 1) {
                  itemName = [aggr.entityType, itemName[0]];
                }

                if (itemName?.length && (!selectedItems.includes(itemName[0]))) {
                  selectedItems.push(itemName[0]);
                }
              }
            });
          });

          if (selectedItems?.length === 1) {
            isInvalid = true;
          }

          console.log('selectedItems :>> 555', selectedItems);
          console.log('isInvalid: ', isInvalid);
        }

        console.log('this.calculatedTagInfo:111 ', JSON.parse(JSON.stringify(this.calculatedTagInfo)));
        console.log('this.itemsCalculatedResult: ', this.itemsCalculatedResult);
        if (!isInvalid) {
          this.calculatedTagDetail.emit(this.calculatedTagInfo);
          this.itemsCalculatedResult.push({ name: this.formGroupTags.value?.name, value: result });
        } else {
          this.itemsCalculatedResult = [];
          this.calculatedTagInfo = { script: '', outputType: '', scriptInputTags: [], scriptInputProps: [], aggConfigs: [], isSingleEntity: true };
          this.calculatedTagDetail.emit(this.calculatedTagInfo);
        }
      }

      if (this.isModel) {
        this.formGroupTags.get("availableComponent").setValue('');
        this.allTags = [];
      }

    } catch (exception) {
      this.toastr.error(exception.message, exception.name);
    }
  }

  /**
   * get output type
   * @param result output result
   */
  getOutputType(result) {
    if (!isNaN(Number(result))) {
      return 'Numeric';
    } else {
      switch (typeof (result)) {
        case 'number': {
          return 'Numeric';
        }

        case 'string': {
          return 'String';
        }

        case 'boolean': {
          return 'Boolean';
        }

        default: {
          return 'Invalid Type!';
        }
      }
    }
  }

  /**
   * text area focus out event to get the current cursor position
   * @param textareaRef textarea input element
   */
  onTextAreaFocusOut(textareaRef: HTMLInputElement) {
    this.cursorPosition = textareaRef.selectionStart;
  }

  /**
   * available selection change event (tag, prop or aggrgegation)
   * @param selectedTag selected tag
   */
  onAvailableChanged(selectedTag: string) {
    if (this.isModel && this.selectedEntity) {
      selectedTag = this.selectedEntity.componentInstanceName ? this.selectedEntity.componentInstanceName + "." + selectedTag : selectedTag;
    }

    const calculatedValue: string = this.formGroupTags.value?.calculated;
    const updatedCalculatedValue: string = [calculatedValue.slice(0, this.cursorPosition), "${" + selectedTag + "}", calculatedValue.slice(this.cursorPosition)].join('');
    this.formGroupTags.get("calculated").setValue(updatedCalculatedValue);
    // on dropdowns focus out
    this.onDropdownFocusOut();
  }

  /**
   * selected component change event
   * @param selectedId selected model id or CI id
   */
  componentChanged(selectedId: string) {
    // this.allTags = this.allModelTags.filter(modelTag => modelTag?.componentInstanceId === componentInstanceId);
    this.allTags = this.allModelTags?.filter((tag: TagDetail) => (tag.componentInstanceId === selectedId || tag.entity_id === selectedId));
    this.allProperties = this.allModelProperties?.filter((property: Property) => (property.componentInstanceId === selectedId || property.entity_id === selectedId));
    this.allAggregations = [];
    const allAggregations: ITimeAggregation[] = [];
    this.componentsService.aggregations$.pipe(takeUntil(this.destroyed)).subscribe((aggregations: ITimeAggregation[]) => {
      if (aggregations.length) {
        allAggregations.push(...aggregations);
        this.allAggregations = allAggregations.filter((aggr: ITimeAggregation) => (aggr.entityId === selectedId || aggr.compInstanceId === selectedId));
      }
    });

    if (this.allComponents[0].modelId === selectedId) {
      this.selectedEntity = (this.selectedModel) as IModelComponents;
    } else {
      this.selectedEntity = this.allComponents?.find(component => component.componentInstanceId === selectedId);
    }
  }

  /**
   * on dropdown focus out event
   */
  onDropdownFocusOut() {
    this.formGroupTags.get("availableTag").setValue('');
    this.formGroupTags.get("availableProp").setValue('');
    this.formGroupTags.get("availableAggr").setValue('');
  }

  /**
   * open dialog model to assign values to selected tags
   * @param index index
   */
  openValueAssismentModel(index: number) {
    console.log('this.itemsDetail :>> open', this.itemsDetail);
    this.dialog.open(TagValueComponent, {
      maxHeight: '80vh', minWidth: '23%', maxWidth: '80%', data: [...this.itemsDetail]
    }).afterClosed().subscribe(tags => {
      console.log('tags:123 ', tags);
      this.itemsDetail = tags?.length ? [...tags] : this.itemsDetail[0].value ? [...this.itemsDetail] : [], this.itemsCalculatedResult = [];
      let calculatedExpression: string = this.formGroupTags.value?.calculated;
      if (this.itemsDetail?.length) {
        // execute given expression with assigned values
        this.execute(calculatedExpression, index, [...this.itemsDetail]);
      }
    });
  }

  /**
   * validation on invertal field
   * allow only integers greater than 0 and without decimals
   * @param event event
   */
  valueValidation(event: any): boolean {
    const intervalValue: string = this.formGroupTags.get('interval').value;
    var regex = new RegExp("^[+-]?[0-9]*$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key) || (!intervalValue && event.key === '0')) {
      event.preventDefault();
      return false;
    }
  }

  //#endregion

  /**
 * get aggregations
 */
  getTimeAggregations() {
    const entityId: string = this.route.snapshot.queryParamMap.get('id');
    // get aggrs by comp id
    if (!this.isModelPage) {
      this.componentsService.getTimeAggrsByCompId(entityId).pipe(take(1)).subscribe((timeAggregations: ITimeAggregation[]) => {
        if (timeAggregations.length) {
          console.log('timeAggregations: ', timeAggregations);
          this.allAggregations = timeAggregations;
          this.componentsService._aggregations.next([...timeAggregations]);
        }
      });
    }
    // get aggrs by model id
    else {
      this.componentsService.getTimeAggrsByModelId(entityId).pipe(take(1)).subscribe((timeAggregations: ITimeAggregation[]) => {
        if (timeAggregations.length) {
          timeAggregations.forEach((timeAggregation: ITimeAggregation) => {
            timeAggregation.dummyName = timeAggregation.compInstanceName ? timeAggregation.compInstanceName + '.' + timeAggregation.name : timeAggregation.name;
          });

          this.allAggregations = [...timeAggregations];
          this.allModelAggregations = [...timeAggregations];
          this.componentsService._aggregations.next([...timeAggregations]);
        }
      });
    }
  }

  ngOnDestroy() {
    this.dynamicDrawerService._createTagFromModel.next(false);
    this.destroyed.next();
    this.destroyed.complete();
  }

}
